import React from "react";
import TimeframeRow from "./TimeframeRow";
import CalendarColumn from "./CalendarColumn";
import ScrollBar from "../../../../../RayCustomControls/ScrollBar/ScrollBar";
import CalendarEvents from "./CalendarEvents";

const EventCalendar = ({ events, allDates, maxRows, loading }) => {
  const viewPortWidth = allDates.length * 100 + 18; 
  const futureEventsRef = React.useRef(null);
  const [height, setHeight] = React.useState(maxRows * 32 + 40);
  const [calendarHeight, setCalendarHeight] = React.useState(600);

  React.useEffect(() => {
    const updateHeight = () => {
      if (futureEventsRef.current) {
        const elementHeight = futureEventsRef.current.offsetHeight;
        setHeight(Math.max(maxRows * 32 + 40, elementHeight-86));
        setCalendarHeight(elementHeight-86);
      }
    };
    updateHeight(); 
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [maxRows]);

  return (
    <div id="futureEvents" className="future-events" ref={futureEventsRef}>
      {loading ? (
        <div className="group-box ">
          <div className="loading loading-spinner"></div>
        </div>
      ) : events.length === 0 ? (
        <div className="no-events">No Events Available</div>
      ) : (
        <>
          <div className="future-event-heading">Future Events</div>
          <div className="calendar custom-scroll">
            <div id="futureListCustomScroll">
              <div
                className="calendar-container custom-scroll"
                style={{
                  width: `${viewPortWidth}px`,
                  '--calendarHeight': `${calendarHeight}px`
                }}
              >
                <div id="calendarCustomScroll"
                >
                  <div className="calendar-columns">
                    {allDates.map((date) => (
                      <CalendarColumn key={date} date={date} height={height} />
                    ))}
                  </div>
                  <CalendarEvents events={events} />
                </div>
              </div>
              <TimeframeRow dates={allDates} width={viewPortWidth} />
              <ScrollBar
                scrollId="calendarCustomScroll"
                hScroll={false}
                vScroll={true}
              />
              <ScrollBar
                scrollId="futureListCustomScroll"
                hScroll={true}
                vScroll={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EventCalendar;
